import { render, staticRenderFns } from "./GestioneTipologieDialog.vue?vue&type=template&id=3dd50c3c&"
import script from "./GestioneTipologieDialog.vue?vue&type=script&lang=js&"
export * from "./GestioneTipologieDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports